import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../material.module';
import { NgxMaskModule } from 'ngx-mask';

import {
  BrazilianCurrencyPipe,
  CpfPipe,
  EllipsisPipe,
  YesNoPipe,
  ImageFilterPipe,
  PrettyJsonPipe,
  JsonToListPipe,
  SentenceCasePipe,
} from './pipes/index';

import {
  ButtonAddMidiaComponent,
  CarouselComponent,
  ContentDialogComponent,
  ContentDialogGenericComponent,
  DynamicFormQuestionComponent,
  HomeComponent,
  InputFileComponent,
  InputImageUploadComponent,
  InputSelectComponent,
  InputTextComponent,
  MainTableComponent,
  ModalComponent,
  ModalErrorsDetailsComponent,
  ModalImageCaptureComponent,
  ModalInputImageUploadComponent,
  ModalQrScannerComponent,
  ProgressCircleComponent,
  TableErrorsComponent,
  UploadTaskListComponent,
  TimelineFilterComponent,
  DynamicTableComponent,
  DynamicTitleComponent,
  DynamicFilterComponent,
  DynamicDialogFormComponent,
  TableLogsComponent,
  FilterLogsComponent,
  ModalLogsComponent,
  UploadImagesMobileComponent,
  RecordVideoDialogComponent,
  DaterangeFilterComponent,
  JsonModalComponent,
  ScreeningMobileUploadEvidencesComponent,
  EvidencesModalComponent,
  TradeResultDetailsComponent,
} from './components';

import { ModalQrUploadMobileComponent } from './components/modal-qr-upload-mobile/modal-qr-upload-mobile.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { DivergenceFileUploadComponent } from '../ips/screening/components/divergence-file-upload/divergence-file-upload.component';
import {
  DivergenceReportContentComponent,
  ModalDivergenceReportPreviewComponent,
} from '../ips/screening/components';
import { UploadVideosMobileComponent } from './components/upload-videos-mobile/upload-videos-mobile.component';
import { DialogEditUfComponent } from './components/dialog-edit-uf/dialog-edit-uf.component';
import { DialogHistoryLocationsComponent } from './components/dialog-history-locations/dialog-history-locations.component';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ModalCreateErrorComponent } from './components/modal-create-error/modal-create-error.component';
import { TableErrorsManagerComponent } from './components/table-errors-manager/table-errors.component';
import { DialogEditTradeDetailsComponent } from './components/dialog-edit-trade-details/dialog-edit-trade-details.component';
import { ModalHistoryTradeDetailsComponent } from './components/modal-history-trade-details/modal-history-trade-details.component';

import { ImeiValidatorComponent } from './components/imei-validator/imei-validator.component';
import { RejectModalQcComponent } from './components/reject-modal-qc/reject-modal-qc.component';
import { RepairRecordComponent } from './components/repair-record/repair-record.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { ImportResumeDialogComponent } from './components/import-resume-dialog/import-resume-dialog.component';
import { OccurrenceBlockComponent } from './components/occurrence-block/occurrence-block.component';
import { ImageBoardComponent } from './components/image-board/image-board.component';
import { ImeiStepComponent } from './components/imei-step/imei-step.component';
import { CpfCnpjDirective } from './directives/cpf-cnpj.directive';
import { ModalDevolutionReasonsComponent } from './components/modal-devolution-reasons/modal-devolution-reasons.component';
import { DialogHistoryImeiTradesComponent } from './components/dialog-history-imei-trades/dialog-history-imei-trades.component';
import { DialogLaudoB2bComponent } from './components/dialog-laudo-b2b/dialog-laudo-b2b.component';
import { DialogLaudoB2cComponent } from './components/dialog-laudo-b2c/dialog-laudo-b2c.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

const SharedPipes = [
  BrazilianCurrencyPipe,
  CpfPipe,
  EllipsisPipe,
  YesNoPipe,
  ImageFilterPipe,
  PrettyJsonPipe,
  JsonToListPipe,
  SentenceCasePipe,
  CpfCnpjDirective,
];

const SharedComponents = [
  MainTableComponent,
  ModalComponent,
  CarouselComponent,
  InputSelectComponent,
  InputTextComponent,
  InputFileComponent,
  ContentDialogComponent,
  ContentDialogGenericComponent,
  ButtonAddMidiaComponent,
  ProgressCircleComponent,
  UploadTaskListComponent,
  ModalQrScannerComponent,
  HomeComponent,
  DynamicFormQuestionComponent,
  InputImageUploadComponent,
  ModalInputImageUploadComponent,
  ModalImageCaptureComponent,
  TableErrorsComponent,
  ModalErrorsDetailsComponent,
  TimelineFilterComponent,
  ModalQrUploadMobileComponent,
  UploadImagesMobileComponent,
  TableLogsComponent,
  FilterLogsComponent,
  ModalLogsComponent,
  DynamicTableComponent,
  DynamicTitleComponent,
  DynamicFilterComponent,
  DynamicDialogFormComponent,
  DivergenceFileUploadComponent,
  ModalDivergenceReportPreviewComponent,
  DivergenceReportContentComponent,
  UploadVideosMobileComponent,
  RecordVideoDialogComponent,
  DaterangeFilterComponent,
  DialogEditUfComponent,
  DialogHistoryLocationsComponent,
  JsonModalComponent,
  ScreeningMobileUploadEvidencesComponent,
  EvidencesModalComponent,
  TableErrorsManagerComponent,
  ModalCreateErrorComponent,
  DialogEditTradeDetailsComponent,
  ModalHistoryTradeDetailsComponent,
  ImeiValidatorComponent,
  RejectModalQcComponent,
  RepairRecordComponent,
  ImportResumeDialogComponent,
  OccurrenceBlockComponent,
  ImageBoardComponent,
  ImeiStepComponent,
  ModalDevolutionReasonsComponent,
  DialogHistoryImeiTradesComponent,
  DialogLaudoB2bComponent,
  DialogLaudoB2cComponent,
  TradeResultDetailsComponent,
];

@NgModule({
  declarations: [...SharedPipes, ...SharedComponents],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    HttpClientModule,
    NgxMaskModule,
    NgxQRCodeModule,
    MatToolbarModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatPaginatorModule,
    MatMenuModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    NgxMaskModule,
    MatDatepickerModule,
    MatNativeDateModule,

    ...SharedComponents,
    ...SharedPipes,
    CpfCnpjDirective,

    CurrencyPipe,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
